<!--
    Plate 立牌
-->
<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌" name="立牌">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in plate"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="plateFormActive">
              <OrdinaryPlate v-if="plate[0].status"/>
              <MultilayerPlate v-if="plate[1].status"/>
              <PendantPlate v-if="plate[2].status"/>
              <AnotherPlate v-if="plate[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import OrdinaryPlate from "./Plate/OrdinaryPlate.vue";
import MultilayerPlate from "./Plate/MultilayerPlate.vue";
import PendantPlate from "./Plate/PendantPlate.vue";
import AnotherPlate from "./Plate/AnotherPlate.vue";

export default {
  name: "Plate",
  methods: {},
  components: {
    OrdinaryPlate,
    MultilayerPlate,
    PendantPlate,
    AnotherPlate
  },
  data() {
    return {
      forcollapse: ['普通立牌','多层场景立牌','挂立两用立牌','其他立牌'],
      plate: [
        { id: "OrdinaryPlate", name: "普通立牌", status: false },
        { id: "MultilayerPlate", name: "多层场景立牌", status: false },
        { id: "PendantPlate", name: "挂立两用立牌", status: false },
        { id: "AnotherPlate", name: "其他立牌", status: false }
      ],
      plateFormActive: []
    };
  }
};
</script>
<style scoped>
</style>